import { Component, Signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationCamera } from '../../../../types';

type CellParams = ICellRendererParams<LocationCamera> & {
  disableActions: Signal<boolean>;
  deleteCallback: (item: LocationCamera) => void;
  previewCallback: (item: LocationCamera) => void;
  editClicked: (item: LocationCamera) => void;
  branchId: () => number;
};

@Component({
  selector: 'app-pan-cell-location-edit-camera-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-location-edit-camera-actions.component.html',
  styleUrl: './cell-location-edit-camera-actions.component.scss',
})
export class CellLocationEditCameraActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
